import React from "react";
import { createRoot } from "react-dom/client";
import "@ant-design/v5-patch-for-react-19";
import { AdminApp } from "./App";
import { captureAdminException, initAdminSentry } from "./lib/sentry";
import "antd/dist/reset.css";
import "@refinedev/antd/dist/reset.css";

// Boot admin observability before React mounts so router, auth, and operator errors share one release envelope.
initAdminSentry();

class AdminErrorBoundary extends React.Component<React.PropsWithChildren, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    void captureAdminException(error, {
      action: "render-error-boundary",
      feature: "admin-shell",
    });
  }

  render() {
    if (this.state.failed) {
      return <div>Something went wrong.</div>;
    }

    return this.props.children;
  }
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AdminErrorBoundary>
      <AdminApp />
    </AdminErrorBoundary>
  </React.StrictMode>,
);
